import React from 'react';
import { useTranslation } from "react-i18next";
import { BsX } from 'react-icons/bs';
import { getIsForPblModeBrowser } from "../../../lib/HandsUpClient";

const PowerOffLive = ({ selectedLiveInfo, handleSelectedFunc }) => {
    const { t } = useTranslation();
    const isPblModeBrowser = getIsForPblModeBrowser();
    const supportedProgram = isPblModeBrowser
        ? t("전원_종료_지원_프로그램_PBL", { ns: "live" })
        : t("전원_종료_지원_프로그램_WINDOWS", { ns: "live" });

    const handlePreventClick = (e) => {
        e.stopPropagation();
    }

    return (
        <div className="hc-unified-alert-card hc-live-alert-card" onClick={handlePreventClick}>
            <div className="hc-unified-alert-header">
                <span className="hc-unified-alert-kicker">POWER</span>
                <button type="button" className="hc-unified-alert-close" onClick={() => handleSelectedFunc({ selectedFunc: "POWER_OFF_TOGGLE", liveSeq:-1 })} aria-label="닫기">
                    <BsX />
                </button>
            </div>
            <div className="hc-unified-alert-title">
                <span>{t("클래스_전원_종료_문구_1", { ns: "live" })}</span>
                <span>{t("클래스_전원_종료_문구_2", { ns: "live" })}</span>
            </div>
            <div className="hc-unified-alert-message">
                <span>{t("전원_종료_지원_안내", { ns: "live" })}</span>
            </div>
            <div className="hc-unified-alert-details">
                <div className="hc-unified-alert-detail-row">
                    <span className="hc-unified-alert-label">{t("클래스_이름", { ns: "live" })}</span>
                    <span className="hc-unified-alert-value" title={selectedLiveInfo.liveName}>
                        {selectedLiveInfo.liveName}
                    </span>
                </div>
                <div className="hc-unified-alert-detail-row">
                    <span className="hc-unified-alert-label">{t("지원_프로그램", { ns: "live" })}</span>
                    <span className="hc-unified-alert-value hc-power-off-support-value">
                        {supportedProgram}
                    </span>
                </div>
            </div>
            <div className="hc-unified-alert-actions">
                <button type="button" className="hc-unified-alert-btn hc-unified-alert-btn-danger" onClick={() => handleSelectedFunc({ selectedFunc: "POWER_OFF", liveSeq: selectedLiveInfo.liveSeq, liveName:selectedLiveInfo.liveName })}>{t("예", { ns: "common" })}</button>
                <button type="button" className="hc-unified-alert-btn hc-unified-alert-btn-secondary" onClick={() => handleSelectedFunc({ selectedFunc: "POWER_OFF_TOGGLE", liveSeq: -1 })}>{t("아니오", { ns: "common" })}</button>
            </div>
        </div>
    );
}

export default PowerOffLive;
